import { render, staticRenderFns } from "./InnerMenu.vue?vue&type=template&id=0bc0dd27&scoped=true&"
import script from "./InnerMenu.vue?vue&type=script&lang=js&"
export * from "./InnerMenu.vue?vue&type=script&lang=js&"
import style0 from "./InnerMenu.vue?vue&type=style&index=0&id=0bc0dd27&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc0dd27",
  null
  
)

export default component.exports